import React from 'react';
import { View, StyleSheet, Platform, ViewStyle } from 'react-native';

interface DesktopGridProps {
  children: React.ReactNode;
  style?: ViewStyle | ViewStyle[];
  columns?: number; // default 3
  gap?: number; // px gap
}

export const DesktopGrid: React.FC<DesktopGridProps> = ({ children, style, columns = 3, gap = 16 }) => {
  return (
    <View style={[styles.container, Platform.OS === 'web' ? { display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gridGap: gap } as any : { flexDirection: 'row', flexWrap: 'wrap', gap }, style]}> 
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
  },
});


